import { NICmsContentComponent } from '@icms/core/content';

export namespace NCmsBlogCategory {
    export const typeId = 'blog-category';

    /**
     * Top blog page url
     */
    export const blogOrigin = '/blog';

    export interface ITypeData {
        /**
         * Pull topCopy and name from parent page
         */
        useParent: boolean;
        topCopy: string;
        /**
         * If true then tag will redirect location
         * otherwise they will act as a filter without changes
         */
        tagRedirect: string;
        components: NICmsContentComponent.IData[];
    }
}
